var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61",
    "data-name": "Group 61",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.346,
    height: 21.583,
    viewBox: "0 0 21.346 21.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 4.921,
    height: 13.753,
    transform: "translate(1.019 7.83)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M1779.464,729.669h3.8v1.91s.584-1.927,4.1-1.927c2.9,0,4.972,1.129,4.972,4.23v9.54h-4.056s.022-8.022.045-8.27a2.273,2.273,0,0,0-2.292-2.27,2.5,2.5,0,0,0-2.719,2.607v7.933h-3.843Z",
    transform: "translate(-1770.984 -721.839)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.461,
    cy: 2.461,
    r: 2.461,
    transform: "translate(0 3.48) rotate(-45)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0acb887fc631fd981949ba3caf979208.svg";
export { ForwardRef as ReactComponent };